import DashboardMain from '@/views/Dashboard/Main'

const module = [
  {
    path: 'dashboard',
    name: 'DashboardMain',
    component: DashboardMain
  }
];

export default module;


// WEBPACK FOOTER //
// ./src/router/modules/dashboard.js